import zhLocale from 'element-ui/lib/locale/lang/zh-CN'; // 引入element语言包

const cn = {
  Multilingual: {
    siteName: '数字南海',
    siteIntroduce: '数据管理与共享平台',
    welcome: '欢迎您！',
    logout: '注销',
    login: '登录',
    loginTip: '严禁在本互联网非密平台，处理、传输国家秘密。',
    register: '注册',
    myOrder: '我的订单',
    FAQ: '常见问题',
    scrollDown: '往下拉',
    latestData: '最新数据',
    latestNews: '最新新闻',
    latestEvents: '最新事件',
    popularData: '热门数据',
    dataDownloading: '数据下载量',
    dataAssociation: '数据关联',
    dataAssociationDesc: '我们构建南海海洋数据资源体系，给已整合的数据做关联，将存在联系的数据连接起来，以便用户利用这些数据再做相关分析。',
    datasets: '数据集',
    featuredDatasets: '精选数据集',
    viewMore: '查看更多',
    events: '社会热点',
    month: '月',
    news: '中心动态',
    voyageSurveyNetwork: '航次调查网',
    aboutUs: '关于我们',
    subject: '主题',
    leaveYourEmailAddress: '留下您的邮箱',
    submit: '提 交',
    anyQuestions: '有啥疑问和问题直接咨询我吧!',
    aboutUsDesc: '南海海洋数据中心成立于2010年，在"国家-广东省-中科院"三个层面上构建由国家地球系统科学数据中心南海及邻近海区分中心、广东省海洋科学数据共享平台、中国科学院优秀所级中心组成的业务化运行服务架构，贯彻"共建共享"数据工作机制，构建基于"数据池"的可重构数据组织，实现热带海洋区域特色数据资源全生命周期管理与服务，为全国海洋系统及涉海企业事业单位、共建高校及其相关学科研究人员与专业技术人员等提供全面、科学、权威的数据和资料，形成以海洋大数据驱动科技创新发展的数据开放共享新生态，支撑智慧海洋发展。',
    mainPartners: '合作伙伴',
    noData: '没有数据了！',
    downloads: '下载量',
    home: '首页',
    metaData: '元数据',
    contactUs: '我的需求',
    detail: '详情',
    edit: '修改',
    addToOrder: '加入订单',
    clear: '清空',
    addToCart: '加入购物车',
    emptyCart: '清空购物车',
    seaArea: '海域',
    subjectSort: '学科',
    subjectKeyword: '要素主题词',
    project: '项目',
    unit: '单位',
    deviceName: '仪器设备',
    view: '查看',
    customQuery: '自定义查询',
    quickSearch: '快速查询',
    search: '搜索',
    query: '查 询',
    dataComparison: '数据对比',
    fullTextSearch: '全文搜索',
    coordinate: '地理坐标',
    map: '地图',
    longitude: '经',
    latitude: '纬',
    keyword: '关键词',
    pleaseEnterKeywords: '请输入关键词',
    confirm: '确 定',
    cancel: '取 消',
    dot: '点',
    rectangle: '矩形',
    closeDrawing: '关闭绘图',
    selectLocation: '选择位置',
    dataName: '数据名称',
    dataEntity: '数据实体',
    dataUsageSituation: '数据使用情况',
    dataVolume: '数据量',
    listOfDataServices: '数据服务列表',
    all: '全部',
    orderNumber: '订单号',
    orderTime: '下单时间',
    dataList: '数据清单',
    operation: '操作',
    delete: '删除',
    userLogin: '用户登录',
    freeSignUp: '免费注册',
    account: '账号',
    password: '密码',
    validate: '验证',
    rememberPassword: '记住密码',
    forgetPassword: '忘记密码',
    logInWithCstCloudAccount: '用中国科技云通行证登录',
    userName: '用户名称',
    realName: '真实姓名',
    email: '电子邮箱',
    phoneNumber: '手机号码',
    workUnit: '工作单位',
    setPassword: '设置密码',
    repeatPassword: '重复密码',
    pleaseEnterYourAccount: '请输入账号',
    pleaseEnterYourPassword: '请输入密码',
    pleaseEnterYourPasswordAgain: '请再输入密码',
    pleaseEnterYourUserName: '请输入用户名称',
    pleaseEnterYourRealName: '请输入真实姓名',
    pleaseEnterYourEmail: '请输入电子邮箱',
    pleaseEnterYourPhoneNumber: '请输入手机号码',
    pleaseEnterYourWorkUnit: '请输入工作单位',
    pleaseEnterYourVerificationCode: '请输入验证码',
    yourPhoneNumberIsInvalid: '手机号格式不正确',
    yourEmailAddressIsInvalid: '邮箱格式不正确',
    clickToUpdate: '点击更新',
    retrievePassword: '找回密码',
    confirmAccount: '确认账户',
    resetPassword: '重置密码',
    resetCompleted: '重置完成',
    previous: '上一步',
    next: '下一步',
    downloadNum: '下载次数',
    visitNum: '访问次数',
    verificationCode: '验证码',
    pleaseEnterYourVerificationCodeFromEmail: '请输入邮件中的验证码',
    newPassword: '新密码',
    pleaseEnterNewPassword: '请输入新密码',
    passwordAgainDifferent: '两次输入的密码不一致!',
    passwordRuleTips: '不能包含空格，长度为8到20个字符，必须包含大写字母、小写字母、数字、符号',
    confirmNewPassword: '确认新密码',
    pleaseEnterNewPasswordAgain: '请再次输入新密码',
    resetCompletedTips: '恭喜，账号重置密码成功，请重新登录',
    goToLogin: '前往登录',
    backToLastPage: '返回上一页',
    description: '描述',
    save: '保存',
    personalInformation: '个人信息',
    basicInformation: '基本信息',
    fileList: '文件列表',
    frequentlyAskedQuestions: '常见问题解答',
    downloadByNeed: '请根据自己的需要，下载对应的版本。',
    required: '必填',
    userAuthentication: '用户认证',
    emailAuthentication: '邮箱认证',
    subjectAuthentication: '课题认证',
    ordinaryUser: '普通用户',
    ordinaryUserDesc: '在数字南海平台上注册，即为普通用户',
    authenticatedUser: '认证用户',
    authenticatedUserDesc: '完成用户手机或邮箱认证，即升级为实名用户，可以获得更多数据资源',
    subjectUser: '课题用户',
    subjectUserDesc: '完成课题信息认证，即升级为课题用户，可以获得与研究课题相关的精品数据',
    subjectCertificationRecord: '课题认证记录',
    subjectName: '课题名称',
    subjectType: '课题类型',
    subjectGrade: '课题级别',
    endTime: '结束时间',
    status: '状态',
    subjectAuthenticationInformation: '课题认证信息',
    subjectAuthenticationInformationDesc: '1. 如果所申请的数据用于项目研究，请填写项目相关信息(项目类型、名称、编号、负责人等)，并将数据所支撑项目/课题的任务书或合同书首页、预期成果及研究目标、考核指标、主要参加人员以及任务书盖章页扫描后通过附件上传。',
    fileSizeTips: '2. 所上传的附件单个文件大小不要超过5MB！',
    subjectDetailDesc: '3. 课题认证只有您本人是课题或项目负责人的才能通过认证！',
    taskBookTitle: '任务书名称',
    taskBookLevel: '任务书等级',
    projectLevel: '项目级',
    topicLevel: '课题级',
    thematicLevel: '专题级',
    taskTakingUnit: '任务承担单位',
    taskBookType: '任务书类型',
    taskBookNumber: '任务书编号',
    taskForceLeader: '任务书负责人',
    executionEndTime: '执行结束时间',
    selectTheDateTime: '选择日期时间',
    subjectProofMaterial: '课题证明材料',
    taskBookHomePage: '任务书首页',
    pleaseSelect: '请选择',
    Upload: '上传',
    expectedResultsAndResearchObjectives: '预期成果及研究目标',
    assessmentIndex: '考核指标',
    listOfParticipants: '参加人员名单',
    taskBookSealPage: '任务书盖章页',
    userNameCannotBeEmpty: '用户名称不能为空',
    realNameCannotBeEmpty: '真实姓名不能为空',
    emailCannotBeEmpty: '电子邮箱不能为空',
    mobilePhoneNumberCannotBeEmpty: '手机号码不能为空',
    workUnitsShouldNotBeEmpty: '工作单位不能为空',
    taskBookNameCannotBeEmpty: '任务书名称不能为空',
    taskBookLevelCannotBeEmpty: '任务书等级不能为空',
    taskTakingUnitsShouldNotBeEmpty: '任务承担单位不能为空',
    thePersonInChargeOfTheTaskShouldNotBeEmpty: '任务书负责人不能为空',
    taskBookNumberCannotBeEmpty: '任务书编号不能为空',
    executionEndTimeCannotBeEmpty: '执行结束时间不能为空',
    taskBookTypeCannotBeEmpty: '任务书类型不能为空',
    assessmentIndicatorsShouldNotBeEmpty: '考核指标不能为空',
    theListOfParticipantsCannotBeEmpty: '参加人员名单不能为空',
    expectedResultsAndResearchObjectivesShouldNotBeEmpty: '预期成果及研究目标不能为空',
    taskBookStampPageCanNotBeEmpty: '任务书盖章页不能为空',
    taskBookHomepageShouldNotBeEmpty: '任务书首页不能为空',
    site: '站点',
    operationWebsite: '运维网站',
    clickToVisit: '点击访问',
    website1: '南海及邻近海区科学数据中心',
    website2: '中国科学院南海海洋数据库',
    website3: '广东省海洋科学数据共享平台',
    website4: '数字海丝路平台',
    website5: '数字大湾区平台',
    website6: '南海科考故事',
    websiteDesc1: '南海海洋数据中心于2011年加入国家地球系统科学数据共享服务平台，2012年通过科技部认定，2019年升级为南海及邻近海区科学数据中心。立足南海，全面汇聚南海及印度洋海区的“观测-遥感-模式”数据及产品，资源涵盖物理海洋、海洋生物、海洋地质、海洋生态等学科，形成具有热带区域特色的海洋数据资源体系，不断加强权威数据资源的发布共享，更好地服务于海洋科学研究、海洋环境保护、海洋防灾减灾、海洋权益维护、海洋知识传播。',
    websiteDesc2: '南海海洋数据库基于中国科学院信息化专项，自2002年建设开始，经过十五、十一五、十二五、十三五共四个发展阶段，持续贯彻“共建共享”数据工作机制，系统整合1985年以来的南海海洋科学考察数据，研究创建“南海海洋数据典藏模型”，创新贯穿科研的“数据全生命周期”数据服务，实现数据资源统一汇聚管理和信息知识融合，建立多元、异构的海洋数据关联网络，融入中国科技云服务环境，大幅度提升了南海海洋数据开放共享服务支撑面。',
    websiteDesc3: '广东省海洋科学数据共享平台基于广东省科技计划项目，重点围绕广东省管辖海域及邻近海域，依托南海海洋所长期、丰富的数据积累，整合广东省海洋科学考察航次与野外科学观测研究站的数字资源，建立广东省海洋数据“共建共享”机制，建设广东省海洋科学数据资源公共服务平台，丰富广东省科学数据资源体系，提高广东省海洋数据资源加工整合能力和服务能力，为全省用户提供海洋数据共享服务，提供数据整合技术支撑和应用培训服务。',
    websiteDesc4: '南海海洋数据中心于2018年为“地球大数据科学工程”项目开发建设印度洋海洋大数据平台，结合实测、遥感和数值模拟技术，形成具有自主知识产权的印度洋高分辨率海洋灾害数据产品，建立印度洋海洋生态环境对海洋动力环境、过程和海洋灾害的响应机制，为印度洋沿岸国家提供海洋灾害信息服务，为印度洋海上航行安全提供信息保障。2022年为中国-斯里兰卡热带海洋环境“一带一路”联合实验室升级印度洋大数据中心，持续服务海上丝绸之路。',
    websiteDesc5: '南海海洋数据中心于2020年为广州海洋实验室开发建设该平台，整合大湾区海洋-生态观测和遥感数据，建立三维海洋动力-大气-生地化耦合的数值模型和预报系统，厘清由人类活动和气象海洋灾害等加剧对水动力场的影响及其环境效应，揭示陆地与海洋之间的水交换及水文环境要素的变化特征和规律，量化陆源入海物质输运和生态要素的长期变化趋势，为大湾区的陆-海-气相互作用研究、海洋环境保护、生态安全保障提供基础科技支撑服务。',
    websiteDesc6: '南海科考故事数据库基于南海及其附属岛礁海洋科学考察历史资料系统整编项目，精心梳理出一批档案文书、航海日志、研究报告、珍贵照片、视频、音频等资料，收录了自50 年代起南海海洋科技工作者们前赴后继，为祖国海洋科研事业奋斗终身的一个个感人的故事，是一个时代的缩影，是一代人的集体记忆，折射出了他们求真务实、报国为民、无私奉献的爱国情怀和高尚品格，弘扬了“锐意进取、攻坚克难、精诚团结、科学创新”的南海精神。',
    viewByVoyage: '按航次查看',
    customFilter: '自定义筛选',
    // 订单详情
    expired: '已过期',
    days: '天',
    hours: '小时',
    minutes: '分钟',
    seconds: '秒',
    auditOperation: '审核操作',
    auditResults: '审核结果',
    auditTime: '审核时间',
    auditReply: '审核回复',
    submitToReview: '提交审核',
    // 使用情况
    username: '用户名称',
    dept: '所在机构',
    usagePurpose: '用途',
    usageTime: '使用时间',

    // 数据使用用途
    dataUsage: '数据用途',
    listOfData: '数据清单',
    userInformation: '用户信息',
    usePurpose: '使用目的',
    selectTheDataUse: '选择数据用途',
    dataUse: '数据用途',
    projectName: '项目名称',
    addingNewUses: '添加新用途',
    dataApplicationDescription: '数据应用说明',
    submitTheApplication: '提交申请',
    applicationType: '应用类型',
    papersTitles: '论文/题目',
    name: '名称',
    projectNumber: '项目编号',
    schoolInformation: '学校信息',
    projectLeader: '项目负责人',
    tutorName: '导师姓名',
    personInCharge: '负责人',
    projectUndertaker: '项目承担单位',
    tutorContact: '导师联系方式',
    commitmentUnit: '承担单位',
    graduationTime: '毕业时间',
    relatedMaterials: '相关材料',

    // 专题案例字段
    relatedResources: '相关资源',
    addRelatedResources: '添加相关资源',
    classicCase: '经典案例',
    addClassicCase: '添加经典案例',
    instituteContactLocal: '院地对接',
    serviceObject: '服务对象',
    serviceTime: '服务时间',
    backgroundAndSignificanceOfServices: '服务的背景和意义',
    serviceContentAndMode: '服务内容和方式',
    organizationalManagement: '组织管理情况',
    achievements: '取得的成效',

    // 元数据详情字段
    dataCoreDescriptionInformation: '数据核心描述信息',
    dataTitle: '数据标题',
    dataIdentification: '数据标识',
    subjectKeywords: '主题关键词',
    factorWord: '主题要素词',
    timeResolution: '时间分辨率',
    dataTime: '数据时间',
    spatialLocation: '空间位置',
    spatialScale: '空间尺度',
    spatialResolution: '空间分辨率',
    scale: '比例尺',
    dataGeneration: '数据产生方式',
    dataType: '数据类型',
    subjectCategory: '学科类别',
    dataDescription: '数据详细描述',
    dataSourceDescription: '数据来源项目',
    dataProductionMethod: '数据生产方法',
    dataProjectionInformation: '数据投影信息',
    dataQualityInformation: '数据质量信息',
    dataAccessMode: '数据访问方式',
    DOINumber: 'DOI号',
    dataContributor: '数据贡献者',
    nameOfDataContributor: '数据贡献者姓名',
    dataContributorMailbox: '数据贡献者邮箱',
    dataContributorUnit: '数据贡献者单位',
    dataReferenceAndStatement: '数据引用方式及声明',
    emailNotificationOfDataBeingUsed: '数据被使用时电子邮件通知',
    dataResponsibleUnitsAndContacts: '数据负责单位及联系人',
    nameOfDataResponsibleUnit: '数据负责单位名称',
    addressOfDataResponsibleUnit: '数据负责单位地址',
    postalCodeOfDataResponsibleUnit: '数据负责单位邮编',
    nameOfDataContact: '数据联系人姓名',
    contactMailbox: '联系人邮箱',
    contactPhone: '联系人电话',
    associatedDevice: '关联设备',
    device: '设备',
    dataAttachment: '数据附件',
    dataDocument: '数据文档',
    dataSample: '数据样例',
    thumbnail: '缩略图',
    shared: '共享条件',
    sharedType: { 11: '完全开放共享', 13: '认证用户共享', 14: '认证课题共享', 21: '须经本人同意共享' },

    // 首页导航
    bigData: '大数据可视',
    browseData: '浏览数据',
    accessProducts: '获取产品',
    downloadSoftware: '下载软件',
    bigDataVisualization: '大数据可视',
    stations: '台站服务',
    geospatialData: '地理空间数据',
    thematicSelectedCharacteristicHotspot: '专精特新',
    thematicService: '专题服务',
    characteristicService: '特色服务',
    excellentResources: '精品资源',
    projectServices: '项目服务',
    integratedForecastService: '集成预报服务',
    dataExchangeService: '汇交服务',
    dataCatalogService: '数据空间',
    dataCatalog: '数据目录',
    disciplineGroupSpace: '学科组空间',
    dirKeeper: '目录保管人',
    laboratory: '实验室',
    boutiqueImages: '查看图集',

    // 汇交服务
    dataAuditing: '数据审核',
    voyageObservationDataExchange: '航次数据汇交',
    stationObservationDataExchange: '台站数据汇交',
    projectResearchDataExchange: '项目研究数据汇交',
    articleLinkedDataExchange: '文章关联数据汇交',
    degreeThesisDataExchange: '学位论文数据汇交',
    personalDataProductExchange: '科学家（个人）数据产品汇交',
    dataPool: '数据池',
    addProject: '新增项目',
    addMetaData: '新增元数据',
    chooseMetadata: '选择元数据',
    projectIntroduction: '项目介绍',
    projectInformation: '项目信息',
    projectPrincipal: '项目负责人',
    projectType: '项目类型',
    executionCycle: '执行期限',
    executionCycleStartDate: '执行期限开始时间',
    executionCycleEndDate: '执行期限结束时间',
    backgroundImage: '背景图片',
    addArticle: '新增文章',
    revokeReview: '撤销审核',
    articleName: '文章名称',
    addPaper: '新增论文',
    paperName: '论文名称',
    author: '作者',
    degree: '学位',
    major: '学科专业',
    studentId: '学号',
    paperTopics: '论文题目',
    time: '时间',
    tutor: '导师',
    addPersonalDataProduct: '新增数据产品',
    awards: '获奖情况',
    content: '获奖情况',

    // 南海诸岛
    geography: '基础地理',
    environmentalObservation: '环境观测',
    ecology: '生态系统',
    geology: '地质环境',
    earthObservation: '对地观测',
    atmosphere: '大气环境',
    vegetationGreening: '植被绿化',
    corrosionInvestigation: '腐蚀调查',
    energy: '波浪能源',
    selectToFilterDataType: '选择筛选数据类型',
    standard: '标准',
    satellite: '卫星',

    // 科考故事
    scientificStory: '科考故事',

    // 查看、喜欢/收藏、转发、分享
    views: '查看',
    likes: '喜欢',
    collection: '收藏',
    forward: '转发',
    shares: '分享',

    // 专精特新
    synthesizeType: ['专题资源', '精选资源', '特色资源', '新热资源'],

    // 台站
    stationName: '台站名称',
    buildDate: '建站时间',
    circleLayer: '圈层',

    // 科普专栏
    popularScience: '科普专栏',

    // 浮潜标
    buoy: '浮标',
    submarine: '潜标',
    buoySubmarine: '浮标潜标网',

    // 商品
    buyNow: '立即购买',
    purchased: '已购买',
    metaDataCode: '元数据编号',
    code: '编号',
    price: '价格',
    balance: '余额',
    userCenter: '用户中心',
    orderNo: '订单号',
    transactionTime: '交易时间',
    ownerAccount: '拥有者账号',
    ownerUnit: '拥有者单位',
    consumerAccount: '消费者账号',
    consumerUnit: '消费者单位',
    download: '下载',

    // 知识图谱
    knowledgeGraph: '关联分析',

    // 数据中心
    dataCenter: '虚拟交易系统',
    dataMarket: '数据市场',
    dataAsset: '我的数据资产',
    dataCommodity: '我的数据商品',
    transactionRecord: '我的交易记录',
    transactionNetwork: '我的交易网络',
    digitalBabe: '我的数字贝币',
    income: '我的收入',
    expend: '我的支出',
    myCollection: '我的收藏',

    // 数据申请
    dataApply: '数据申请',
    myPendingReview: '我的待审核',
    pendingReview: '待审核',
    myReviewed: '我的已审核',
    myApply: '我的申请',
    agree: '同意',
    reject: '拒绝',
    reviewComment: '审核意见',
    orderDetail: '订单详情',
    audit: '审核',

    category: '类别',
    platformMatrix: '平台矩阵',
    pleaseEnterSearchContent: '请输入搜索内容',

    helpCenter: '帮助',
    instructions: '使用说明',
    introduction: '介绍',
    documentDetail: '文档详情',
    document: '文档',
    commonProblem: '常见问题',
    southChinaSeaIntroduction: '数字南海简介',
    developmentHistory: '发展历程',
    websiteFeatures: '网站功能',
    ipAddress: 'IP地址',
    fileSize: '文件大小',
  },
  ...zhLocale,
};

export default cn;



// WEBPACK FOOTER //
// ./src/i18n/langs/cn.js